




















import Component from 'vue-class-component'
import Configuration from '@/modules/configuration/domain/configuration'
import DocumentField from '@/modules/common/components/form/documentField.vue'
import { Getter } from 'vuex-class'
import Invoice from '@/modules/invoice/domain/invoice'
import { Prop } from 'vue-property-decorator'
import Vue from 'vue'

@Component({
  components: { DocumentField }
})
export default class InvoiceHeaderPrint extends Vue {
  @Prop({ type: Invoice, required: true }) invoice!: Invoice
  @Getter('first', { namespace: 'configuration' }) configuration?: Configuration
}
